<template>
  <el-dialog :title="$t('shopSetting.addSetting')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form :model="addShopSettingInfo" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item :label="$t('shopSetting.settingType')" prop="settingType">
        <el-select v-model="addShopSettingInfo.settingType" @change="_changeSettingType" style="width:100%"
          :placeholder="$t('shopSetting.selectSettingTypeRequired')">
          <el-option v-for="(item, index) in settingTypes" :key="index" :label="item.name"
            :value="item.statusCd"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('shopSetting.settingName')" prop="settingName">
        <el-select v-model="addShopSettingInfo.settingName" @change="_changeSettingName" style="width:100%"
          :placeholder="$t('shopSetting.selectSettingNameRequired')">
          <el-option v-for="(item, index) in addShopSettingInfo.keys" :key="index" :label="item.settingName"
            :value="item.settingName"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('shopSetting.settingKey')" prop="settingKey">
        <el-input v-model="addShopSettingInfo.settingKey" disabled
          :placeholder="$t('shopSetting.inputSettingKeyRequired')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('shopSetting.settingValue')" prop="settingValue">
        <el-input v-model="addShopSettingInfo.settingValue"
          :placeholder="$t('shopSetting.inputSettingValueRequired')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('shopSetting.remark')">
        <el-input type="textarea" v-model="addShopSettingInfo.remark"
          :placeholder="$t('shopSetting.inputRemarkOptional')"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveShopSettingInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId,getDict } from '@/api/shop/shopApi'
import { saveShopSetting, queryShopSettingKey } from '@/api/goods/shopSettingApi'

export default {
  name: 'AddShopSetting',
  data() {
    return {
      dialogVisible: false,
      settingTypes:[],
      addShopSettingInfo: {
        shopId: getShopId(),
        settingName: '',
        settingType: '',
        settingKey: '',
        keys: [],
        settingValue: '',
        remark: ''
      },
      rules: {
        settingType: [
          { required: true, message: this.$t('shopSetting.settingTypeRequired'), trigger: 'blur' }
        ],
        settingName: [
          { required: true, message: this.$t('shopSetting.settingNameRequired'), trigger: 'blur' }
        ],
        settingKey: [
          { required: true, message: this.$t('shopSetting.settingKeyRequired'), trigger: 'blur' }
        ],
        settingValue: [
          { required: true, message: this.$t('shopSetting.settingValueRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getSettingTypes()
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    async getSettingTypes() {
      try {
        const { data } = await getDict('shop_setting_key', 'setting_type')
        this.settingTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addShopSettingInfo = {
        shopId: getShopId(),
        settingName: '',
        settingType: '',
        settingKey: '',
        keys: [],
        settingValue: '',
        remark: ''
      }
    },
    async saveShopSettingInfo() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return

        try {
          await saveShopSetting(this.addShopSettingInfo)
          this.$message.success(this.$t('common.saveSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('保存失败:', error)
        }
      })
    },
    async _changeSettingType() {
      try {
        const res = await queryShopSettingKey({
          page: 1,
          row: 50,
          shopId: getShopId(),
          settingType: this.addShopSettingInfo.settingType
        })
        this.addShopSettingInfo.keys = res.data
        this.addShopSettingInfo.settingKey = this.$t('shopSetting.selectSettingKeyRequired')
      } catch (error) {
        console.error('获取配置key失败:', error)
      }
    },
    _changeSettingName() {
      const selected = this.addShopSettingInfo.keys.find(
        item => item.settingName === this.addShopSettingInfo.settingName
      )
      if (selected) {
        this.addShopSettingInfo.settingKey = selected.settingKey
        this.addShopSettingInfo.remark = selected.remark
      }
    }
  }
}
</script>